import {
  Divider,
  Typography
} from '@mui/material';
import TextField from '@mui/material/TextField';
import React from 'react';
import {SupportTicketModel} from '../../../../model/support/support-ticket.model';
import {
  SupportTicketUtils
} from '../utils/support-ticket.utils';
import { Box } from '@mui/material';

type Props = {
  ticket: SupportTicketModel
  translate: (key: string) => string
  translateLocal: (key: string) => string
}

export const SupportTicketDrawerCustomerResolution = ({ticket, translate, translateLocal}: Props) => {
  const buildHeader = () => (
    <Box mt={1} pt={1}>
      <Box display="flex" alignItems="center" ml={0.5} mb={0.5}>
        {SupportTicketUtils.getStatusIcon(ticket.status) && (
          <Box
            mr={0.5}
            color={SupportTicketUtils.getStatusIconColor(ticket.status)}
            display="flex"
            alignItems="center"
          >
            {React.createElement(SupportTicketUtils.getStatusIcon(ticket.status), { fontSize: "small" })}
          </Box>
        )}
        <Typography variant="body1" fontWeight={600} letterSpacing={1} mr={1} lineHeight={1}>
          Weryfikacja rozwiązania zgłoszenia: {translate(`support.ticket.status.${ticket.status}`)}
        </Typography>
      </Box>
      <Divider sx={{ my: 1 }} />
    </Box>
  )

  const buildCustomerComment = () =>  <Box mt={3}>
    <TextField
      disabled={true}
      label={translateLocal('ticket.drawer.customerComment')}
      value={ticket.customerComment}
      required
      multiline
      minRows={5}
      maxRows={5}
      fullWidth
      sx={{
        '& .MuiInputBase-root': {
          overflow: 'auto',
        },
      }}
    />
  </Box>

  return <>
    {buildHeader()}
    {buildCustomerComment()}
  </>
}